import { Divider, Grid, Tab, Tabs } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { useStores } from '../../../stores';
import MedicalHistoryDetails, {
  RiskPatientDataDetails,
} from '../../organisms/MedicalHistoryDetails';
import PatientDetailsCareGapsTab from '../PatientDetailsCareGapsTab';

import PatientDetailsOverviewTab from '../PatientDetailsOverviewTab';
import {
  BasicTable,
  CardComponent,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import EmptyTable from '../../atoms/EmptyTable';
import { getInfoIcon } from '../../../core-utils/helper-utils/infoIconHelper';
import PatientCaseHistoryTab from '../PatientCaseHistoryTab';
import MemberOfInterestModal from '../../organisms/MemberOfInterestModal';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../atoms/Snackbar';

export interface PatientDetailsTabsProps {
  // overviewTabData: any;
  medicalHistoryTabData: RiskPatientDataDetails[];
  careGapsTabData: any;
  adherenceValues: any[];
  activeMedications: any[];
  // rafScoreValues: any[][];
  // polyPharmaInteractionValues: string[][];
  chronicHealthConditions: any[];
  inherentRiskConditions: any[];
  handleDownArrow: () => void;
  showLoadMore?: boolean;
  patientData: any;
  isCareNavigator?: boolean;
  typeOfTriggers: string[];
  referrals: string[];
}

const PatientDetailsTabs: React.FC<PatientDetailsTabsProps> = observer(
  ({
    // overviewTabData,
    medicalHistoryTabData,
    careGapsTabData,
    adherenceValues,
    activeMedications,
    // rafScoreValues,
    // polyPharmaInteractionValues,
    chronicHealthConditions,
    inherentRiskConditions,
    patientData,
    isCareNavigator,
    typeOfTriggers,
    referrals,
  }) => {
    const useStyles = makeStyles()({
      tabsRoot: {
        minHeight: '33px',
        height: '33px',
      },
      tab: {
        textTransform: 'none',
        minHeight: '33px',
        height: '33px',
        minWidth: 'fit-content',
        width: 'fit-content',
        padding: '0px',
      },
      selectedTab: {
        color: `${patientAccessTheme.palette.text.highemphasis} !important`,
      },
      tableContainer: {
        margin: '34px 30px',
        marginBottom: '0px',
        display: 'flex',
        gap: '32px',
      },
    });

    const { classes } = useStyles();

    const getFormattedCurrentDateTime = () => {
      const now = new Date();
      const offsetDate = new Date(
        now.getTime() - now.getTimezoneOffset() * 60000,
      );
      return offsetDate.toISOString().slice(0, 16);
    };

    const moleculeConstants = componentConstants.MOLECULES.PATIENT_DETAILS_TABS;
    const messages = componentConstants.MOLECULES.PATIENT_DETAILS_OVERVIEW_TAB;

    const tabStore = useStores().tabStore;
    const loginPageStore = useStores().loginPageStore;

    const [selectedTabIndex, setSelectedTabIndex] = React.useState(
      tabStore.patientDetailsCurrentTabIndex,
    );
    const [moiData, setMoiData] = useState<any>({
      group_id: '',
      patient_id: '',
      member_id: '-',
      patient_name: '',
      group_name: '',
      type_of_trigger: '',
      priority: '',
      selfAssign: false,
      interaction: false,
      close: false,
      case_id: '',
      cn_id: '',
      interaction_date: getFormattedCurrentDateTime(),
      type: '',
      mode: '',
      referral: '',
      details: '',
      ...patientData,
    });

    const [snackbarState, setSnackbarState] = React.useState<{
      open: boolean;
      message: string;
      severity: MuiColor | undefined;
      duration: null | number;
    }>({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });

    const tabsData = {
      adherenceValues,
      activeMedications,
      // rafScoreValues,
      // polyPharmaInteractionValues,
    };

    const cellStyles = {
      color: patientAccessTheme.palette.text.mediumemphasis,
      fontSize: '12px',
      fontWeight: 500,
    };
    const columnsForTables: any[] = [
      {
        name: 'Condition',
        align: 'left',
        cellStyles: cellStyles,
        width: '200px',
      },
      {
        name: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              ...cellStyles,
            }}
          >
            <div>D.F.D</div>
            <div>
              {getInfoIcon('Date First Diagnosed', () => { }, {
                display: 'flex',
                alignItems: 'center',
              })}
            </div>
          </div>
        ),
        align: 'right',
        cellStyles: cellStyles,
        width: '',
      },
    ];

    const handleCloseSnackBar = () => {
      setSnackbarState({
        open: false,
        message: '',
        severity: undefined,
        duration: null,
      });
    };

    const handleOpenSnackBar = (
      message: string,
      severity: MuiColor,
      duration: number | null,
    ) => {
      setSnackbarState({
        open: true,
        message: message,
        severity: severity,
        duration: duration,
      });
    };

    useEffect(() => {
      setSelectedTabIndex(tabStore.patientDetailsCurrentTabIndex);
    }, [tabStore.patientDetailsCurrentTabIndex]);

    const handleChange = (event: React.ChangeEvent<{}>, index: number) => {
      setSelectedTabIndex(index);
      tabStore.setPatientDetailsCurrentTabIndex(index);
    };

    const isSaveButtonDisabledCase = () => {
      if (
        moiData.priority === '' ||
        moiData.type_of_trigger === '' ||
        (moiData.interaction &&
          (moiData.interaction_date === '' ||
            moiData.type === '' ||
            moiData.mode === ''))
      ) {
        return true;
      }
      return false;
    };

    const handleAccept = async (case_id: string) => {
      await axios
        .post(
          properties.aiqBaseUrl +
          properties.casesBaseUrl +
          properties.acceptCase,
          {
            case_id: case_id,
          },
        )
        .then((response) => {
          if (response.status === 200) {
            handleOpenSnackBar('Case Accepted succesfully', 'success', 6000);
          }
        })
        .catch((error) =>
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
        );
    };

    const handleAddInteraction = async (case_id: string, cn_id: string) => {
      await axios
        .post(
          properties.aiqBaseUrl +
          properties.interactionBaseURL +
          properties.addInteraction,
          {
            patient_id: moiData.patient_id,
            group_id: moiData.group_id,
            case_id: case_id,
            cn_id: cn_id,
            interaction_date: moiData.interaction_date,
            type: moiData.type,
            mode: moiData.mode,
            referral: moiData.referral,
            details: moiData.details,
          },
        )
        .then((response) => {
          if (response.status === 200) {
            handleOpenSnackBar(
              'Interaction added succesfully',
              'success',
              6000,
            );
          }
        })
        .catch((error) =>
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
        );
    };

    const endCase = async (case_id: string, careNavData: any) => {
      await axios
        .post(
          properties.aiqBaseUrl +
          properties.caseSurveyBaseUrl +
          properties.createCaseSurvey,
          {
            case_id: case_id,
            cn_id: careNavData.cnId,
            cn_name: careNavData.firstName + ' ' + careNavData.lastName,
            cn_role: careNavData.role,
            patient_id: moiData.patient_id,
            group_id: moiData.group_id,
          },
        )
        .then((response) => {
          if (response.status === 200) {
            handleOpenSnackBar('Case ended succesfully', 'success', 6000);
          }
        })
        .catch((error) =>
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
        );
    };

    const handleAssignCase = async (case_id: string, careNavData: any) => {
      await axios
        .post(
          properties.aiqBaseUrl +
          properties.casesBaseUrl +
          properties.assignCase,
          {
            case_id: case_id,
            cn_id: careNavData.cnId,
            cn_name: careNavData.firstName + ' ' + careNavData.lastName,
            cn_role: careNavData.role,
            cn_assign_note: '',
          },
        )
        .then((response) => {
          if (response.status === 200) {
            handleAccept(case_id);
            handleOpenSnackBar(
              'Care navigator assigned & accepted succesfully',
              'success',
              6000,
            );
          }
        })
        .catch((error) =>
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
        );
    };

    const handleCreateCase = async () => {
      const careNavData = loginPageStore.userResponse;
      if (!careNavData) {
        handleOpenSnackBar('Care navigator details not found', 'error', 6000);
        return;
      }

      await axios
        .post(
          properties.aiqBaseUrl +
          properties.casesBaseUrl +
          properties.createCase,
          {
            patient_id: moiData.patient_id,
            member_id: moiData.member_id,
            group_name: moiData.group_name,
            type_of_trigger: moiData.type_of_trigger,
            current_health_state: {
              conditions: '',
              medications: '',
              procedures: '',
            },
            priority: moiData.priority,
            group_id: moiData.group_id,
          },
        )
        .then((response) => {
          if (response.status === 200) {
            handleOpenSnackBar('Case added succesfully', 'success', 6000);
            if (loginPageStore.isCareNavigator && moiData.selfAssign) {
              handleAssignCase(response?.data?.data?._id, careNavData);
            }
            if (loginPageStore.isCareNavigator && moiData.interaction) {
              handleAddInteraction(
                response?.data?.data?._id,
                careNavData.cnId ?? '',
              );
            }
            if (loginPageStore.isCareNavigator && moiData.close) {
              endCase(response?.data?.data?._id, careNavData);
            }
          }
          setMoiData({
            group_id: '',
            patient_id: '',
            member_id: '-',
            patient_name: '',
            group_name: '',
            type_of_trigger: '',
            priority: '',
            selfAssign: false,
            interaction: false,
            close: false,
            case_id: '',
            cn_id: '',
            interaction_date: getFormattedCurrentDateTime(),
            type: '',
            mode: '',
            referral: '',
            details: '',
            ...patientData,
          });
        })
        .catch((error) =>
          handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
        );
    };

    const getTabContent = (index: number) => {
      switch (index) {
        case 0:
          return (
            <>
              <Grid className={classes.tableContainer}>
                <CardComponent
                  title="Chronic Health Conditions"
                  subTitle="List of diagnosed long-term health issues"
                  body={
                    <>
                      {chronicHealthConditions?.length > 0 ? (
                        <BasicTable
                          columns={columnsForTables}
                          rowsData={chronicHealthConditions}
                          cellHeight="43px"
                          tableHeight="259px"
                          width="365px"
                          handleHeaderMouseEnter={() => { }}
                          handleHeaderMouseLeave={() => { }}
                          handleOnClick={() => { }}
                        />
                      ) : (
                        <EmptyTable text={messages.EMPTY_TABLE} width="300px" />
                      )}
                    </>
                  }
                />
                <CardComponent
                  title="Inherent Risk Conditions"
                  subTitle="List of conditions linked to family history"
                  body={
                    <>
                      {inherentRiskConditions?.length > 0 ? (
                        <BasicTable
                          columns={columnsForTables}
                          rowsData={inherentRiskConditions}
                          cellHeight="43px"
                          tableHeight="259px"
                          width="365px"
                          handleHeaderMouseEnter={() => { }}
                          handleHeaderMouseLeave={() => { }}
                          handleOnClick={() => { }}
                        />
                      ) : (
                        <EmptyTable text={messages.EMPTY_TABLE} width="300px" />
                      )}
                    </>
                  }
                />
              </Grid>
              <PatientDetailsOverviewTab {...tabsData} />
            </>
          );
        case 1:
          return (
            <div style={{ paddingLeft: '32px', paddingTop: '32px' }}>
              <MedicalHistoryDetails
                riskPatientDetails={medicalHistoryTabData}
              />
            </div>
          );
        case 2:
          return (
            <div style={{ padding: '32px' }}>
              <PatientDetailsCareGapsTab
                careGapsData={careGapsTabData?.SystemRisk}
              />
              <PatientDetailsCareGapsTab
                careGapsData={careGapsTabData?.SelfImposed}
                isSelfImposed
              />
            </div>
          );
        case 3:
          return (
            <PatientCaseHistoryTab
              memberId={patientData.patient_id || ''}
              triggerAPI={true}
            />
          );
        case 4:
          return (
            <Grid>
              <MemberOfInterestModal
                isMOITab={true}
                handleSave={handleCreateCase}
                isSaveButtonDisabled={isSaveButtonDisabledCase()}
                moiDataState={[moiData, setMoiData]}
                typeOfTriggers={typeOfTriggers}
                isCareNavigator={isCareNavigator}
                referrals={referrals}
              />
            </Grid>
          );
      }
      return <></>;
    };

    return (
      <div>
        <Tabs
          value={selectedTabIndex}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="secondary"
          className={classes.tabsRoot}
        >
          <Tab
            label={moleculeConstants.OVERVIEW}
            className={classes.tab}
            classes={{
              selected: classes.selectedTab,
            }}
            style={{ marginRight: '49px', marginLeft: '34px' }}
          />
          <Tab
            label={moleculeConstants.MEDICAL_HISTORY}
            className={classes.tab}
            classes={{
              selected: classes.selectedTab,
            }}
            style={{ marginRight: '49px' }}
          />
          {/* <Tab
            label={moleculeConstants.CARE_GAPS}
            className={classes.tab}
            classes={{
              selected: classes.selectedTab,
            }}
            style={{ marginRight: '49px' }}
          /> */}
          {patientData.patient_id && (
            <Tab
              label={moleculeConstants.CASE_HISTORY}
              className={classes.tab}
              classes={{
                selected: classes.selectedTab,
              }}
              style={{ marginRight: '49px' }}
            />
          )}
          {patientData.patient_id && (
            <Tab
              label={moleculeConstants.CREATE_CASE}
              className={classes.tab}
              classes={{
                selected: classes.selectedTab,
              }}
            />
          )}
        </Tabs>
        <Divider
          style={{ backgroundColor: patientAccessTheme.palette.grey[300] }}
        />

        {getTabContent(selectedTabIndex)}

        <Snackbar
          {...snackbarState}
          vertical={'bottom'}
          horizontal={'right'}
          handleClose={handleCloseSnackBar}
        />
      </div>
    );
  },
);

export default PatientDetailsTabs;
